<div class="w-100 d-flex justify-content-center my-4">
  <button type="submit" class="btn btn-primary col-2"
          [disabled]="isLoading">Save</button>
  <button type="button" class="btn btn-primary col-2 mx-3"
          [disabled]="isLoading" [routerLink]="cancelRedirectUrl">Cancel</button>
</div>
